import { UseCaseModel } from "lib/models/aiforme-models";
import { JobInfo } from "lib/models/oui-models";
import { CatalogicalService } from "lib/services";
import { useState } from "react";

import jobFamiliesMapping from "../../../configuration/AIForMe/jobFamiliesMapping.json";
import { useMessageBannersBox } from "../MessageBannersBox/hook";

const ALL_JOB_FAMILIES = "All";
const AIFORME_DOMAIN_NAME = "aiforme";

const useAiForMeUseCases = () => {
  const [useCases, setUseCases] = useState<UseCaseModel[] | undefined>(undefined);
  const [isLoading, setIsLoading] = useState<boolean>();
  const catalogicalService = new CatalogicalService<UseCaseModel>("usecases");
  const { addErrorBanner } = useMessageBannersBox();

  const randomizeItems = (items: UseCaseModel[]) => {
    return [...items].sort(() => Math.random() - 0.5);
  };

  const scrambleUseCases = () => {
    if (useCases) {
      setUseCases(randomizeItems(useCases));
    }
  };

  const getUseCases = async (jobFamilyName: string) => {
    setIsLoading(true);

    const mappedJobFamily = (jobFamiliesMapping as { [key: string]: string })[jobFamilyName] ?? ALL_JOB_FAMILIES;
    let items: UseCaseModel[] | undefined;
    try {
      items = (
        await catalogicalService.getItems({
          filters: {
            recommendedJobFamilies: [mappedJobFamily],
            applicableDomain: AIFORME_DOMAIN_NAME,
          },
          pageSize: 100,
          sortBy: ["recommendedJobFamilies"],
          sortDirection: ["asc"],
        })
      )?.data;

      if (!items || items.length === 0) {
        // Fallback to retrieving generic set of use cases when no data is found for specific job family
        items = (
          await catalogicalService.getItems({
            filters: {
              recommendedJobFamilies: [ALL_JOB_FAMILIES],
              applicableDomain: AIFORME_DOMAIN_NAME,
            },
            pageSize: 100,
            sortBy: ["recommendedJobFamilies"],
            sortDirection: ["asc"],
          })
        )?.data;
      }

      setUseCases(randomizeItems(items!));
    } catch (error) {
      addErrorBanner("Failed to load common use cases. Please try again later.");
    }

    setIsLoading(false);
  };

  return {
    useCases,
    scrambleUseCases,
    isLoadingUseCases: isLoading,
    getUseCases,
  };
};

export default useAiForMeUseCases;
